import React, {useMemo} from "react";
import {Card} from "peggirkit";
import {MenuItem} from "../../layout/menu/MenuItems";
import {useIntl} from "react-intl";
import {ArrowRightIcon, ArrowTopRightOnSquareIcon} from "@heroicons/react/24/outline";
import {Link} from "react-router-dom";

const DashboardLink = ({icon, ...linkProps}: MenuItem) => {
    const intl = useIntl();
    const {label, href, external, Icon} = useMemo(() => {
        if ("route" in linkProps) {
            return {
                label: linkProps.route.name(intl),
                href: linkProps.route.absolutePath(),
                external: false,
                Icon: icon || ArrowTopRightOnSquareIcon,
            };
        }

        return {
            label: linkProps.name,
            href: linkProps.href,
            external: true,
            Icon: ArrowTopRightOnSquareIcon,
        };
    }, [linkProps, intl, icon]);

    return (
        <Link
            className={"group"}
            to={href}
            title={label}
            {...external ? {
                target: "_blank",
                rel: "nofollow",
            } : {}}
        >
            <Card>
                <div className="w-full flex items-start justify-between mb-3 lg:mb-6">
                    <div
                        className="bg-eat-yellow-600/20 text-eat-yellow-800 dark:bg-eat-yellow-600/5 dark:text-eat-yellow-600 rounded p-2 lg:p-3">
                        <Icon className={"w-4 h-4 lg:w-6 lg:h-6"}/>
                    </div>

                    <ArrowRightIcon
                        className={"transition-colors w-4 lg:w-6 text-gray-300 group-hover:text-gray-400 dark:text-gray-600 dark:group-hover:text-gray-400"}
                    />
                </div>

                <strong className={"w-full block overflow-hidden text-lg lg:text-xl text-ellipsis"}>
                    {label}
                </strong>
            </Card>
        </Link>
    );
};

export default DashboardLink;